import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Card, Col, Container, Modal, Row, Form } from "react-bootstrap"
import { getSinesterTypes, importSinesterTypesFromEbroker  } from "../../actions/other/sinestersActions"
import { RootState, AppDispatch } from "../../store"
import { CustomDataTable } from "../../components/design/Datatables/CustomDataTable"
import { useAuth } from "../../components/auth/useAuth"
import { useTranslation } from "react-i18next"
import Swal from "sweetalert2"

export interface SinesterType {
    _id?: string
    name?: string
    ebrokerId?: number
}

export default function SinesterTypeManagement() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()
    const dispatch: AppDispatch = useDispatch()

    const [page, setPage] = useState<number>(1)
    const [limit, setLimit] = useState<number>(25)
    const [search, setSearch] = useState<string>("")
    const [totalRows, setTotalRows] = useState<number>(0)

    const { sinesterTypes, loadingtypes } = useSelector((state: RootState) => state.sinesters)

    useEffect(() => {
        if (clientauth) {
            dispatch(getSinesterTypes() as any)
        }
    }, [dispatch, t, clientauth])

    const handleImportSinesterTypes = () => {
        Swal.fire({
            icon: 'question',
            title: t('sinesterTranslate.importSinestersTypes')!,
            text: t('sinesterTranslate.importSinestersTypesAreYouSure')!,
            showDenyButton: true,
            confirmButtonText: t('global.ok')!,
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(importSinesterTypesFromEbroker())
            }
        })
    }

    const columnsCompanias = [
        {
            name: t("sinesterTranslate.ebrokerId"),
            selector: (sinester: SinesterType) => sinester.ebrokerId?.toString() || "-",
            sortable: true,
            maxWidth: "160px",
            center: true,
        },
        {
            name: t("sinesterTranslate.name"),
            selector: (sinester: SinesterType) => sinester.name || "",
            sortable: true,
            wrap: true,
        }
    ]


    return (
        <Container className='p-1 py-5 p-md-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('menus.sinestersType')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <button className="btn btn-primary" onClick={handleImportSinesterTypes}>
                        {t("sinesterTranslate.importSinestersTypesFromEbroker")}
                    </button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    {loadingtypes ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                            <div className="spinner-border" role="status"></div>
                                                <span className="sr-only">{t("global.loading")}</span>
                                        </div>
                                    ) : sinesterTypes?.length > 0 ? (
                                        <CustomDataTable
                                            columns={columnsCompanias}
                                            data={sinesterTypes}
                                            search={search}
                                            setSearch={setSearch}
                                            page={page}
                                            setPage={setPage}
                                            limit={limit}
                                        />
                                    ) : (
                                        <h4 className="mt-4">{t("sinesterTranslate.thereisnotsinesterstypes")}</h4>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}